// Mollie JavaScript SDK types
export interface MollieOptions {
	locale?: string;
	testmode?: boolean;
}

export interface MollieComponentOptions {
	styles?: {
		base?: MollieComponentStyles;
		valid?: MollieComponentStyles;
		invalid?: MollieComponentStyles;
	};
	components?: {
		cardHolder?: { label?: string };
		cardNumber?: { label?: string };
		verificationCode?: { label?: string };
		expiryDate?: { label?: string };
	};
}

export interface MollieComponentStyles {
	backgroundColor?: string;
	color?: string;
	fontSize?: string | number;
	fontWeight?: string | number;
	letterSpacing?: string | number;
	lineHeight?: string | number;
	textAlign?: string;
	textDecoration?: string;
	textTransform?: string;
	"::placeholder"?: {
		color?: string;
	};
}

export const MOLLIE_COMPONENTS = [
	"card",
	"cardNumber",
	"cardHolder",
	"expiryDate",
	"verificationCode",
] as const;
export type MollieComponentType = (typeof MOLLIE_COMPONENTS)[number];

export interface MollieChangeEvent extends Event {
	touched?: boolean;
	error?: string;
}

export interface MollieComponent {
	mount(selector: string | HTMLElement): void;
	unmount(): void;
	addEventListener(
		event: "change",
		handler: (event: MollieChangeEvent) => void,
	): void;
	removeEventListener(
		event: "change",
		handler: (event: MollieChangeEvent) => void,
	): void;
}

export interface TokenResult {
	token?: string;
	error?: {
		// Actually INSANE that they shipped an API like this
		message: string | false;
		statusCode: number;
		detail: string;
	};
}

export interface MollieInstance {
	createComponent(
		type: MollieComponentType,
		options?: MollieComponentOptions,
	): MollieComponent;
	createToken(): Promise<TokenResult>;
}

export type MollieConstructor = (
	profileId: string,
	options?: MollieOptions,
) => MollieInstance;

declare global {
	interface Window {
		Mollie?: MollieConstructor;
	}
}
